import { render } from "./HrPageLayout.vue?vue&type=template&id=2f75fd6e&scoped=true"
import script from "./HrPageLayout.vue?vue&type=script&lang=js"
export * from "./HrPageLayout.vue?vue&type=script&lang=js"

import "./HrPageLayout.vue?vue&type=style&index=0&id=2f75fd6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f75fd6e"]])

export default __exports__